import { AnyObject } from '@chem-po/core'
import { Form } from '../../types'
import { getInsuranceInfoStage } from '../introduction'
import { allergiesField } from './allergies'
import { gynContactInfoField } from './contact'
import { familyAndGeneticHistoryField } from './familyHistory'
import { gynAndSexualHistoryField } from './gynAndSexualHistory'
import { healthHistoryField } from './healthHistory'
import { medicationsAndSupplementsField } from './medicationsAndSupplements'
import { socialHistoryStage } from './socialHistory'

export const getGynIntroductionForm = (
  admin: boolean,
  insuranceInfo: AnyObject | undefined,
): Form => ({
  name: 'Introduction',
  description: 'Tell us a little bit about yourself',
  stages: {
    contact: gynContactInfoField,
    insuranceInfo: getInsuranceInfoStage(insuranceInfo, admin, true),
    familyAndGeneticHistory: familyAndGeneticHistoryField,
    healthHistory: healthHistoryField,
    socialHistory: socialHistoryStage,
    gynAndSexualHistory: gynAndSexualHistoryField,
    allergies: allergiesField,
    medicationsAndSupplements: medicationsAndSupplementsField,
    // sexualBehavior: sexualBehaviorField,
    // conditionsOrDiseases: conditionsOrDiseasesField,
    // neurologicalPsychological: neurologicalPsychologicalField,
    // injuriesAndSurgeries: injuriesAndSurgeriesField,
    // immunizations: immunizationsField,
  },
})
